import { render, staticRenderFns } from "./add-ware-module.vue?vue&type=template&id=74d4bde6&scoped=true"
import script from "./add-ware-module.vue?vue&type=script&lang=ts"
export * from "./add-ware-module.vue?vue&type=script&lang=ts"
import style0 from "./add-ware-module.vue?vue&type=style&index=0&id=74d4bde6&prod&lang=stylus&module=true"
import style1 from "./add-ware-module.vue?vue&type=style&index=1&id=74d4bde6&prod&lang=stylus&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "74d4bde6",
  null
  
)

export default component.exports